import * as React from "react";
import { useBilling } from "../../components/Kitchen/billingProvider";
import { useCountry } from "../courtryProvider";
import { sumBy } from "lodash";
import { useSelector } from "react-redux";
import { useCustomerData } from "./customerDataProvider";

const FooterDataContext = React.createContext();

const initialState = {
  shippingAddress: "",
  billingAddress: "",
  discount: "",
  discountType: "flat",
  coupon: {},
  couponDiscountType: "NA",
  otherCharges: [],
  notes: "",
  couponDiscountAmount: 0,
};
const FooterDataProvider = ({ children, ...props }) => {
  const [footerData, setFooterData] = React.useState(initialState);
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const { customerData } = useCustomerData();
  const { state, getSubTotal } = useBilling();
  const country = useCountry();
  const clearFooterData = React.useCallback(() => {
    setFooterData(initialState);
  }, []);

  console.log("customerData987", customerData);

  const applyCoupon = React.useCallback(
    (couponData) => {
      let result = 0;

      if (couponData) {
        if (Object.keys(couponData).length > 0) {
          result = 0;
        }
        const subTotal = getSubTotal();
        if (parseFloat(subTotal) < parseFloat(couponData.condition.minPrice)) {
          alert(
            `Cannot Apply coupon. The bill value should be more than ${country.CurrencySymbol}.${couponData.condition.minPrice} to avail this coupon.`
          );
          return;
        }
        const discountValue = parseFloat(couponData?.discountAmount || 0);
        const discountType = couponData?.discountType;
        if (discountType === "percentage") {
          result = (parseFloat(subTotal) * parseFloat(discountValue)) / 100;
        } else {
          result = discountValue;
        }
      }
      setFooterData((prev) => ({
        ...prev,
        coupon: couponData,
        couponDiscountAmount: result,
      }));
      return result;
    },
    [country.CurrencySymbol, getSubTotal]
  );

  const removeCoupon = React.useCallback(() => {
    setFooterData((prev) => ({
      ...prev,
      coupon: {},
      couponDiscountAmount: 0,
    }));
  }, []);

  const getOtherChargeValue = React.useCallback(
    (product) => {
      const otherCharges = footerData.otherCharges;

      const sumOtherCharges = sumBy(otherCharges, (o) =>
        parseFloat(o.price || 0)
      );
      return sumOtherCharges;
    },
    [footerData.otherCharges]
  );

  const setDeliveryAddress = React.useCallback(
    (billingAddress, shippingAddress) => {
      setFooterData((prev) => ({
        ...prev,
        shippingAddress: shippingAddress,
        billingAddress: billingAddress,
      }));
    },
    []
  );

  const getLoyaltyDiscount = React.useCallback(() => {
    let result = 0;
    const loyaltyDiscount = customerData.loyaltyDiscount;
    if (loyaltyDiscount > 0) {
      result = parseFloat(loyaltyDiscount || 0);
    }
    return result;
  }, [customerData.loyaltyDiscount]);

  const getDiscountValue = React.useCallback(() => {
    let result = 0;
    const subTotal = getSubTotal();
    const discount = footerData.discount || 0;
    const discountType = footerData.discountType;
    if (discountType === "flat") {
      result = parseFloat(discount);
    } else {
      result = (parseFloat(subTotal || 0) * parseFloat(discount || 0)) / 100;
    }
    return result;
  }, [footerData.discount, getSubTotal, footerData.discountType]);

  const getRoundOff = React.useCallback(() => {
    if (invoiceSettings.roundOff) {
      const subTotal = getSubTotal();
      const otherCharge = getOtherChargeValue();
      const discount = getDiscountValue();
      const loyaltyDiscount = getLoyaltyDiscount();
      const couponDiscountAmount = footerData.couponDiscountAmount;
      const coupon = footerData.coupon;
      if (subTotal < coupon.condition?.minPrice) {
        removeCoupon(coupon);
      }
      console.log("loyaltyDiscount1", loyaltyDiscount);
      const total =
        parseFloat(subTotal) +
        parseFloat(otherCharge) -
        couponDiscountAmount -
        discount -
        loyaltyDiscount;

      const roundedTotal = invoiceSettings.roundOff
        ? Math.round(total) - total
        : 0;
      return roundedTotal;
    }
    return 0;
  }, [
    getSubTotal,
    getOtherChargeValue,
    getDiscountValue,
    footerData.coupon,
    footerData.couponDiscountAmount,
    invoiceSettings.roundOff,
    removeCoupon,
    getLoyaltyDiscount,
  ]);

  const AddDiscountOtherCharge = React.useCallback(
    (isDiscount, isOtherCharge, isNotes) => {
      const data = {};
      if (!isDiscount) {
        data["discount"] = "";
        data["discountType"] = "";
      }
      if (!isOtherCharge) {
        data["otherCharges"] = [];
      }
      if (!isNotes) {
        data["notes"] = "";
      }

      setFooterData((prev) => ({
        ...prev,
        ...data,
      }));
    },
    []
  );

  const getTotalAmount = React.useCallback(() => {
    const subTotal = getSubTotal();
    const otherCharge = getOtherChargeValue();
    const discount = getDiscountValue();
    const loyaltyDiscount = getLoyaltyDiscount();
    const couponDiscountAmount = footerData.couponDiscountAmount;
    const coupon = footerData.coupon;
    if (subTotal < coupon.condition?.minPrice) {
      removeCoupon(coupon);
    }
    const total =
      parseFloat(subTotal) +
      parseFloat(otherCharge) -
      couponDiscountAmount -
      discount -
      loyaltyDiscount;

    const roundedTotal = invoiceSettings.roundOff
      ? Math.round(total)
      : parseFloat(total).toFixed(2);
    return roundedTotal;
  }, [
    getSubTotal,
    getOtherChargeValue,
    getDiscountValue,
    footerData.coupon,
    footerData.couponDiscountAmount,
    invoiceSettings.roundOff,
    removeCoupon,
    getLoyaltyDiscount,
  ]);

  const memorizedValue = React.useMemo(() => {
    return {
      footerData,
      setFooterData,
      applyCoupon,
      removeCoupon,
      clearFooterData,
      getOtherChargeValue,
      getTotalAmount,
      getRoundOff,
      AddDiscountOtherCharge,
      setDeliveryAddress,
      getLoyaltyDiscount,
    };
  }, [
    footerData,
    applyCoupon,
    setFooterData,
    removeCoupon,
    clearFooterData,
    getOtherChargeValue,
    getTotalAmount,
    getRoundOff,
    AddDiscountOtherCharge,
    setDeliveryAddress,
    getLoyaltyDiscount,
  ]);

  React.useEffect(() => {
    if (state.addedProducts?.length === 0) {
      clearFooterData();
    }
  }, [state.addedProducts, clearFooterData]);
  return (
    <FooterDataContext.Provider value={memorizedValue} {...props}>
      {children}
    </FooterDataContext.Provider>
  );
};

export default FooterDataProvider;

export const useFooterData = () => {
  const context = React.useContext(FooterDataContext);
  if (context === undefined) {
    throw new Error(`useFooterData must be used within a FooterDataProvider`);
  }
  return context;
};
